import { Box, Text } from "@chakra-ui/react";
import ArrivalRatesPerHourTable from "../tables/ArrivalRatesPerHourTable";
import { ARRIVAL_RATES_FREQUENCIES } from "../../../store/constants";
import { useSelector } from "react-redux";
import * as defaultSelectors from "../../../store/selectors/defaultSelector";
import {
  ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  normalizeRenderConfig,
  sortReportRows,
} from "../../../store/renderConfig";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../store/reportEnterpriseInsights";

const ArrivalRatesPerHour = ({ reportIndex, data }) => {
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const config = normalizeRenderConfig(renderConfig, {
    columnDefinitions: ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  });
  const rows = config.charts.enabled
    ? data
    : sortReportRows(
        data.map((item) => ({ ...item, scopeName: item.branchName })),
        config,
        { columnDefinitions: ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS }
      );
  
  return (
    <Box>
      {rows.map((data, index) => {
        const { branchName, numServices } = data;
        const title = `${reportIndex || ""}.${index + 1}. ${branchName}`;
        const insights = buildArrivalInsights(data, { scopeLabel: "Branch" });
        return (
          <Box key={index}>
            <h2>{title}</h2>
            <Text>{numServices} services</Text>
            <EnterpriseReportSummary
              title="Hourly Arrival Demand Summary"
              kpis={insights.kpis}
              tables={insights.tables}
              notes={insights.notes}
            />
            <ArrivalRatesPerHourTable
              data={data}
              index={index}
              frequency={ARRIVAL_RATES_FREQUENCIES.HOUR}
              renderConfig={config}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ArrivalRatesPerHour;
